<template>
  <svg
    id="Capa_1"
    enable-background="new 0 0 512 512"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g fill="#554e56">
        <path
          d="m159.163 254.844c0 16.285 13.201 29.486 29.486 29.486 4.555 0 8.868-1.034 12.719-2.879-.056.74-.093 1.484-.093 2.238 0 9.763 4.748 18.414 12.058 23.78h27.366c3.308-.001 6-2.692 6-6v-20.948l-.809-.157c-27.289-5.304-50.364-23.678-61.726-49.15l-.264-.593h-12.056c-7.662 5.325-12.681 14.186-12.681 24.223z"
        />
        <path
          d="m362.862 231.214c-11.36 25.473-34.436 43.847-61.725 49.15l-.81.157v20.948c0 3.308 2.691 5.999 5.999 6h27.366c7.31-5.366 12.058-14.017 12.058-23.78 0-.754-.038-1.498-.093-2.238 3.851 1.844 8.164 2.879 12.719 2.879 16.285 0 29.486-13.201 29.486-29.486 0-10.037-5.019-18.898-12.681-24.223h-12.056z"
        />
      </g>
      <g>
        <path
          d="m405.376 306.469h-263.726c-28.448 0-51.509 23.061-51.509 51.509v17.25l1.054 1h21.652v-12.574c0-2.289 1.862-4.151 4.151-4.151h80.327c2.289 0 4.151 1.862 4.151 4.151v12.574h27.739c2.289 0 4.151 1.862 4.151 4.151v130.621h-.055l1.055 1h212.217c5.689 0 10.302-4.612 10.302-10.302v-143.72c0-28.447-23.061-51.509-51.509-51.509z"
          fill="#26a6fe"
        />
        <path
          d="m111.847 375.229v-11.575c0-2.845 2.306-5.151 5.151-5.151h11.629v-.31c0-7.349 2.78-14.047 7.343-19.105 7.536-19.098 26.142-32.618 47.918-32.618h-42.238c-28.448 0-51.509 23.061-51.509 51.509v17.25z"
          fill="#0593fc"
        />
        <g>
          <g>
            <path
              d="m410.527 471.823h-88.596c-1.707 0-3.091-1.384-3.091-3.091v-55.63c0-1.707 1.384-3.091 3.091-3.091h88.596c1.707 0 3.091 1.384 3.091 3.091v55.63c0 1.707-1.384 3.091-3.091 3.091z"
              fill="#fff"
            />
          </g>
          <g>
            <path
              d="m350.777 468.732v-55.63c0-1.707 1.384-3.091 3.091-3.091h-31.936c-1.707 0-3.091 1.384-3.091 3.091v55.63c0 1.707 1.384 3.091 3.091 3.091h31.936c-1.708 0-3.091-1.384-3.091-3.091z"
              fill="#f3f0f3"
            />
          </g>
          <g>
            <path
              d="m381.682 393.818h-30.905c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h30.905c4.143 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z"
              fill="#f3f0f3"
            />
          </g>
        </g>
      </g>
      <path
        d="m437.404 110.868h-10.833c6.59-2.123 11.362-8.299 11.362-15.596 0-9.051-7.338-16.389-16.389-16.389h-3.988c3.243-3.927 5.046-8.205 5.046-12.688 0-18.979-31.954-34.364-71.372-34.364-17.871 0-34.195 3.168-46.713 8.396-10.927-17.07-43.754-32.69-84.049-38.214-51.491-7.059-95.676 5.041-98.69 27.026-1.106 8.067 3.491 16.343 12.29 23.938h-8.585c-9.051 0-16.389 7.338-16.389 16.389 0 7.297 4.771 13.473 11.362 15.596h-10.833c-9.051 0-16.389 7.338-16.389 16.389 0 9.052 7.338 16.389 16.389 16.389h9.757c-2.514 4.638-3.942 9.95-3.942 15.596 0 15.199 10.346 27.977 24.379 31.687-.65 2.429-1.015 4.971-1.087 7.587 5.368-7.821 14.369-12.963 24.551-12.963h13.482v-6.957c0-2.284 1.86-4.143 4.146-4.143.167 0 .335.01.505.03 1.123.134 2.269.202 3.405.202 12.754 0 23.8-8.198 27.485-20.399.522-1.726 2.135-2.932 3.924-2.932.388 0 .774.057 1.149.169 2.659.795 5.428 1.197 8.231 1.197 12.555 0 23.857-8.388 27.486-20.398.521-1.727 2.135-2.933 3.925-2.933.387 0 .773.057 1.148.169 2.66.795 5.43 1.198 8.231 1.198 10.58 0 20.272-5.795 25.295-15.124.699-1.299 2.082-2.106 3.608-2.106h45.054c16.49 0 29.905 13.415 29.905 29.905v42.121h13.482c16.124 0 29.285 12.891 29.741 28.907 10.734-5.383 18.102-16.486 18.102-29.312 0-5.646-1.428-10.958-3.942-15.596h9.757c9.052 0 16.389-7.338 16.389-16.389.004-9.051-7.333-16.388-16.385-16.388z"
        fill="#554e56"
      />
      <g>
        <path
          d="m138.823 170.759c5.621-7.36 14.483-12.111 24.458-12.111h7.389c-7.304-6.01-11.966-15.114-11.966-25.311 0-3.144.443-6.185 1.269-9.063.941-3.276-1.547-6.533-4.956-6.533h-2.129c-9.051 0-16.389-7.338-16.389-16.389 0-9.051 7.338-16.389 16.389-16.389 2.958 0 4.559-3.372 2.775-5.732-2.074-2.743-3.304-6.159-3.304-9.864 0-9.051 7.338-16.389 16.389-16.389 3.007 0 4.715-3.519 2.785-5.825-4.945-5.906-7.319-12.068-6.49-18.113 1.963-14.322 21.403-24.447 48.95-27.815-48.671-5.229-89.329 6.758-92.216 27.815-1.106 8.067 3.491 16.343 12.29 23.938h-8.585c-9.051 0-16.389 7.338-16.389 16.389 0 7.297 4.771 13.473 11.362 15.596h-10.833c-9.051 0-16.389 7.338-16.389 16.389 0 9.051 7.338 16.389 16.389 16.389h9.757c-2.514 4.638-3.942 9.95-3.942 15.596 0 15.199 10.346 27.977 24.379 31.687-.495 1.852-.828 3.77-.993 5.735z"
          fill="#433f43"
        />
      </g>
      <path
        d="m301.328 301.47v-21.147c-5.373 1.061-10.921 1.631-16.601 1.631h-22.43c-5.679 0-11.227-.569-16.6-1.63v21.147c0 2.761-2.239 5-5 5h-20.755l49.11 85.005c1.983 3.432 6.937 3.432 8.92 0l49.11-85.005h-20.755c-2.76-.001-4.999-2.24-4.999-5.001z"
        fill="#a44f3e"
      />
      <path
        d="m262.298 282.954c-5.68 0-11.226-.564-16.6-1.608v20.124c0 2.761-2.239 5-5 5h-20.755l10.115 17.508h32.123c2.845 0 5.151-2.306 5.151-5.151v-35.873z"
        fill="#883f2e"
      />
      <g>
        <g>
          <path
            d="m176.763 196.418v-37.77h-13.482c-16.99 0-30.762 13.773-30.762 30.762v11.448c0 16.99 13.773 30.762 30.762 30.762h21.094c-4.874-10.744-7.612-22.656-7.612-35.202z"
            fill="#883f2e"
          />
          <path
            d="m383.745 158.648h-13.482v37.77c0 12.546-2.738 24.458-7.611 35.203h21.094c16.99 0 30.762-13.773 30.762-30.762v-11.449c0-16.989-13.773-30.762-30.763-30.762z"
            fill="#a44f3e"
          />
        </g>
        <g>
          <path
            d="m340.358 86.621h-45.054c-1.863 0-3.606.992-4.489 2.633-4.678 8.69-13.854 14.598-24.415 14.598-2.761 0-5.428-.404-7.945-1.156-2.68-.801-5.508.754-6.317 3.432-3.441 11.392-14.014 19.688-26.528 19.688-2.761 0-5.428-.404-7.945-1.156-2.68-.801-5.508.754-6.317 3.432-3.441 11.392-14.014 19.688-26.528 19.688-1.112 0-2.209-.066-3.286-.195-3.069-.366-5.77 2.015-5.77 5.106v43.728c0 47.792 38.743 86.535 86.535 86.535h22.43c47.792 0 86.535-38.743 86.535-86.535v-78.892c-.001-17.069-13.838-30.906-30.906-30.906z"
            fill="#bb5d4c"
          />
        </g>
        <g>
          <g>
            <path
              d="m207.816 196.418v-60.918c-4.974 7.4-13.409 12.279-22.997 12.279-1.112 0-2.209-.066-3.286-.195-3.069-.366-5.77 2.015-5.77 5.106v43.728c0 47.792 38.743 86.535 86.535 86.535h22.43c1.615 0 3.218-.053 4.812-.14-45.553-2.497-81.724-40.218-81.724-86.395z"
              fill="#a44f3e"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="m227.155 189.842c-4.142 0-7.5-3.357-7.5-7.5v-22.109c0-4.143 3.358-7.5 7.5-7.5s7.5 3.357 7.5 7.5v22.109c0 4.142-3.358 7.5-7.5 7.5z"
              fill="#883f2e"
            />
          </g>
          <g>
            <path
              d="m319.871 189.842c-4.143 0-7.5-3.357-7.5-7.5v-22.109c0-4.143 3.357-7.5 7.5-7.5s7.5 3.357 7.5 7.5v22.109c0 4.142-3.357 7.5-7.5 7.5z"
              fill="#883f2e"
            />
          </g>
        </g>
        <g>
          <path
            d="m273.513 206.668h-10.641c-4.576 0-8.673-2.367-10.959-6.331s-2.283-8.695.009-12.655l15.1-26.095c2.075-3.583 6.663-4.808 10.248-2.734s4.81 6.662 2.734 10.248l-13.059 22.567h6.567c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.499 7.5z"
            fill="#883f2e"
          />
        </g>
        <g>
          <path
            d="m273.514 250.379c-11.159 0-22.317-4.248-30.812-12.742-2.929-2.93-2.929-7.678 0-10.607 2.929-2.928 7.678-2.928 10.606 0 11.143 11.144 29.27 11.142 40.41 0 2.93-2.928 7.678-2.928 10.607 0 2.929 2.93 2.929 7.678 0 10.607-8.495 8.494-19.653 12.742-30.811 12.742z"
            fill="#883f2e"
          />
        </g>
      </g>
      <g>
        <path
          d="m273.513 338.93c-12.916 0-25.459-1.59-37.455-4.566l32.995 57.111c1.983 3.432 6.937 3.432 8.92 0l32.994-57.111c-11.995 2.976-24.538 4.566-37.454 4.566z"
          fill="#fff"
        />
      </g>
      <g>
        <path
          d="m259.261 338.278c-7.921-.725-15.67-2.045-23.203-3.914l32.995 57.111c1.983 3.432 6.937 3.432 8.92 0l6.011-10.404z"
          fill="#f3f0f3"
        />
      </g>
      <g>
        <path
          d="m185.697 359.503v-1.31c0-15.76-12.776-28.535-28.535-28.535-15.76 0-28.535 12.776-28.535 28.535v1.31z"
          fill="#e2dee2"
        />
        <g>
          <path
            d="m149.891 358.503v-.31c0-12 7.411-22.263 17.903-26.48-3.287-1.321-6.873-2.055-10.632-2.055-15.759 0-28.535 12.776-28.535 28.535v.31z"
            fill="#cbc4cc"
          />
        </g>
        <path
          d="m229.215 375.229h-27.739v8.688c0 2.288-1.862 4.15-4.151 4.15h-80.327c-2.289 0-4.151-1.862-4.151-4.15v-8.688h-27.739c-2.845 0-5.151 2.306-5.151 5.151v34.753l29.132.001c6.607 0 11.982 5.375 11.982 11.982 0 3.798-1.756 7.292-4.819 9.585-.752.566-1.2 1.462-1.2 2.399 0 .938.448 1.835 1.199 2.398 3.063 2.293 4.819 5.786 4.819 9.585 0 3.797-1.756 7.29-4.819 9.584-.751.563-1.2 1.459-1.2 2.398 0 .938.448 1.834 1.199 2.397 3.063 2.295 4.819 5.789 4.819 9.587 0 3.797-1.756 7.291-4.819 9.585-.752.566-1.2 1.462-1.2 2.398 0 .94.449 1.837 1.2 2.399 3.062 2.293 4.818 5.786 4.818 9.584 0 6.607-5.375 11.982-11.982 11.982v1h125.277v-131.617c.003-2.845-2.303-5.151-5.148-5.151z"
          fill="#f6a96c"
        />
        <g fill="#ea9b58">
          <path d="m109.089 512h3.716v-.548c-1.179.352-2.424.548-3.716.548z" />
          <path
            d="m109.089 414.134c1.292 0 2.537.196 3.716.549v-27.791c-.598-.841-.958-1.864-.958-2.974v-8.688h-26.739c-2.845 0-5.151 2.306-5.151 5.151v33.753z"
          />
        </g>
        <g>
          <path
            d="m197.325 389.068h-80.327c-2.845 0-5.151-2.306-5.151-5.151v-20.263c0-2.845 2.306-5.151 5.151-5.151h80.327c2.845 0 5.151 2.306 5.151 5.151v20.263c0 2.845-2.306 5.151-5.151 5.151z"
            fill="#fff"
          />
        </g>
        <g>
          <path
            d="m144.74 383.917v-20.263c0-2.845 2.306-5.151 5.151-5.151h-32.893c-2.845 0-5.151 2.306-5.151 5.151v20.263c0 2.845 2.306 5.151 5.151 5.151h32.893c-2.844 0-5.151-2.306-5.151-5.151z"
            fill="#f3f0f3"
          />
        </g>
      </g>
      <g>
        <path
          d="m77.37 414.133c-12.272 0-22.255 9.984-22.255 22.256v53.356c0 12.272 9.983 22.255 22.255 22.255h31.719c7.158 0 12.983-5.824 12.983-12.983 0-4.116-1.902-7.9-5.219-10.384-.502-.377-.8-.969-.8-1.599 0-.628.297-1.22.8-1.598 3.317-2.486 5.219-6.271 5.219-10.386s-1.902-7.901-5.219-10.386c-.502-.377-.8-.969-.8-1.598s.297-1.222.8-1.598c3.317-2.485 5.219-6.269 5.219-10.385s-1.902-7.901-5.219-10.385c-.502-.377-.8-.969-.8-1.598s.297-1.221.8-1.598c3.317-2.485 5.219-6.27 5.219-10.386 0-7.157-5.825-12.982-12.983-12.982z"
          fill="#bb5d4c"
        />
      </g>
      <g>
        <path
          d="m82.417 493.441v-60.747c0-7.324 3.127-13.929 8.112-18.56l-13.158-.001c-12.272 0-22.255 9.984-22.255 22.256v53.355c0 12.272 9.983 22.256 22.255 22.256h13.159c-4.986-4.63-8.113-11.235-8.113-18.559z"
          fill="#a44f3e"
        />
      </g>
    </g>
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "EnfermeiraIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
